
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import infoGetActions from '../../../sagas/info';
import { getToken } from '../../../reducers/auth';
import { getProjectKatuzeItems } from '../../../reducers/project';

const LinkToTeleso = ({isknDate, tel}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleClick = () => {
        infoActions.getObjectTeleso(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            tel.tel_id
        );
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o listu vlastnictví">{tel.cislo_tel}</Link>
    )
}

export default LinkToTeleso;
